module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_3.e8183e66.png";